import { createSlice } from "@reduxjs/toolkit";

const tasksSlice = createSlice({
  name: "tasks",
  initialState: {
    DataList: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    tasksDataRequest: (state) => {
      state.isFetching = true;
    },
    tasksDataSuccess: (state, action) => {
      state.isFetching = false;
      state.DataList = action.payload;
    },
    tasksDataFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});
export const { tasksDataRequest, tasksDataSuccess, tasksDataFailure } =
  tasksSlice.actions;
export default tasksSlice.reducer;
